import { defineComponent } from 'vue'
import styles from './index.module.scss'

export default defineComponent({
  name: 'MkReturnBar',
  props: {
  },
  setup() {
    const handleBack = () => {
      window.history.go(-1)
    }
    return () => (
      <div class={`${styles['mk-return-bar']} mk-bg-white flex-s mk-fs-14`}>
        <span class="flex-s" style="height: 100%" onClick={handleBack}>
          <duero-iconfont iconClass={styles.icon} name={`duero-icon-3181568-a-gengduojiantouxin ${styles.icon}`} />
          返回
        </span>
      </div>
    )
  },
})
